import logo from "../../../assets/logo.svg";

const Footer = () => {
  return (
    <footer>
      <img src={logo} alt="logo" />
    </footer>
  );
};

export default Footer;
